// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__kO5B2","frameSquare":"recentes_frameSquare__byyzk","imagem":"recentes_imagem__6PzRH","marca":"recentes_marca__JdvjA","modelo":"recentes_modelo__P2-dn"};